import { EntityMetadata, ViewColumnDefinition, ViewModel } from '@msdk/definitions'

import { getFieldDefIncludeExternal } from '../../../utils'

export function filterableColumns(viewModel: ViewModel, baseMetadata: EntityMetadata): ViewColumnDefinition[] {
  // The column that are allowed to be filtered are normal columns
  // or custom column that have a real entity field behind them

  return viewModel.columns.filter((c) => {
    if ((!c.customUI || (c.customUI && !c.inlineDefinition)) && !c.disableColumnFilter) {
      const fieldDef = getFieldDefIncludeExternal(viewModel, c.fieldName, baseMetadata)
      return fieldDef.fieldDefinitionType !== 'List'
    }
    return false
  })
}
